import type { TreatmentType } from '@/lib/apis/treatments'

const EVENT_NAMES = {
  wl: 'quiz_mid_wq',
  ed: 'quiz_mid_eqs',
  pe: 'quiz_mid_pes',
  mhl: 'quiz_mid_mhs',
} as const satisfies Record<TreatmentType, string>

export function treatmentQuizMidEvent(
  type: TreatmentType,
  storyId: string | null | undefined,
) {
  if (!storyId) return null
  return { event: EVENT_NAMES[type], event_id: storyId }
}
